import { useState } from "react";
import { Star } from "lucide-react";

/**
 * Display 5 stars filled to the rating value. Read-only by default; pass onChange to make it interactive.
 */
export default function StarRating({ value = 0, onChange, size = 18, testid = "star-rating", readOnly }) {
  const [hover, setHover] = useState(0);
  const readonly = !!readOnly || !onChange;
  return (
    <div className="inline-flex items-center gap-0.5" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => {
        const active = (hover || value) >= n;
        return (
          <button
            type="button"
            key={n}
            disabled={readonly}
            onClick={() => onChange && onChange(n)}
            onMouseEnter={() => !readonly && setHover(n)}
            onMouseLeave={() => !readonly && setHover(0)}
            className={`transition-transform ${readonly ? "cursor-default" : "hover:scale-110 cursor-pointer"}`}
            style={{ color: active ? "#f59e0b" : "#d4d4d8" }}
            aria-label={`${n} bintang`}
            data-testid={`star-${n}`}
          >
            <Star size={size} strokeWidth={1.5} fill={active ? "#f59e0b" : "transparent"} />
          </button>
        );
      })}
    </div>
  );
}
